"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseAPI_1 = require("./BaseAPI");
var CacheComparisonWidgetsAPI = /** @class */ (function (_super) {
    tslib_1.__extends(CacheComparisonWidgetsAPI, _super);
    function CacheComparisonWidgetsAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CacheComparisonWidgetsAPI.prototype.getFromCacheAndCompare = function (resourceName, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.request({
                        method: "get",
                        url: "/api/" + resourceName + "/cache_compare/" + id + "/",
                    })];
            });
        });
    };
    return CacheComparisonWidgetsAPI;
}(BaseAPI_1.default));
exports.default = new CacheComparisonWidgetsAPI(window.__WIDGETS_API_URL__);
